import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import SummaryCompletedPage from './SummaryCompletedPage';
import SaveLater from './SaveLater';
// Bootstrap component
import ThankYouPage from '../SurveySubmit/ThankYouPage';
// Assets
import './SurveyCompletePage.css';

 class SurveyCompletePage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pageType:""
        }
    }

    componentDidMount() {
        this.setState({pageType:this.props.pageType})
    }

    renderThankYouPage = (type) => {
        this.setState({pageType:type});
    }

    redirectPage = () => {
        this.setState({pageType:"saveLater"});
    }

    render() {
        const { totalQuestionCount, instrumentList,  pageInstrumentConfiguration, itemList, questionList, itemResponses } = this.props;
        const { pageType } = this.state;
        const { summaryPage } = pageInstrumentConfiguration;

        var answeredQuestion = 0;
        var unAnsweredCount = 0;
        var isRequired = 0;
        var naCount = 0;
        var secondChance = 0;
        var tempListItems = [];

        for (const key in itemList) {
            if (itemList.hasOwnProperty(key)) {
                const listItems = itemList[key];
                for (const key in listItems) {
                    if (listItems.hasOwnProperty(key)) {
                        const element = listItems[key];

                        if (element.isRequired === true && element.reviewPageKey === element.reviewPageKey) {
                           // isRequired = 1;
                        }
                    }
                }
                tempListItems.push(listItems[0])
            }
        }
        if (tempListItems && tempListItems.length > 0) {

            tempListItems.filter((item, i) => {
                if (tempListItems.indexOf(item) === i) {

                    /* Required question count */
                    if (item.isRequired === true && item.requiredIndicator === 2) {
                        isRequired++;
                    }

                    if (item.isAnswer === false && item.requiredIndicator === 1) {
                        secondChance++;
                    }
                     /* Required question count */
                     if (item.isNA === true) {
                        naCount++;
                    }

                    /* Answered and unaswered question count */
                    if (item.isAnswer === true || item.isNA === true) {
                        answeredQuestion++;
                        isRequired = item.isRequired === true  && item.requiredIndicator === 2 ? isRequired = isRequired - 1 : isRequired;
                    } else {
                        unAnsweredCount++;
                    }
                }
            });
        }

        return (
            <Fragment>
                { pageType === "finish" && !summaryPage.pageDisabled ?
                    <SummaryCompletedPage
                        totalQuestionCount={totalQuestionCount}
                        isRequiredCount={isRequired}
                        answeredQuestion={answeredQuestion}
                        unAnsweredCount={unAnsweredCount}
                        secondChance={secondChance !== undefined ? secondChance: 0 }
                        naCount={naCount}
                        instrumentList={instrumentList}
                        pageInstrumentConfiguration={pageInstrumentConfiguration}
                        openModal={(type) => this.props.openModal(type, false)}
                        redirectSavePage={this.redirectPage}
                        itemResponses={itemResponses}
                        handleFinalAsSubmitButton={(e) => this.props.handleFinalAsSubmitButton(null, null, null, "FinalSubmit")}
                        renderThankYouPage={(type) => this.renderThankYouPage(type)}
                    /> : pageType === "thankYouPage" ?
                        <ThankYouPage
                            pageInstrumentConfiguration={pageInstrumentConfiguration}
                            instrumentList={instrumentList}
                        />
                    :null
                    // <SaveLater
                    //     totalQuestionCount={totalQuestionCount}
                    //     isRequiredCount={isRequired}
                    //     answeredQuestion={answeredQuestion}
                    //     unAnsweredCount={unAnsweredCount}
                    //     naCount={naCount}
                    //     instrumentList={instrumentList}
                    //     openModal={(type) => this.props.openModal(type, false)}
                    // />

                }
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    itemList:state.survey.itemList,
    instrumentList:state.survey.instrument,
});

export default connect(mapStateToProps)(SurveyCompletePage);
